import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Modal } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
export default function PreferencesModal(_ref) {
  let {
    closeModal,
    children
  } = _ref;
  return createElement(Modal, {
    className: "interface-preferences-modal",
    title: __('Preferences'),
    closeLabel: __('Close'),
    onRequestClose: closeModal
  }, children);
}
//# sourceMappingURL=index.js.map